import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const ROOT_CLASS_NAME = tv({
  base: clsx(
    "bg-ui-200 data-[state=checked]:bg-ui-400 border border-ui-300 data-[state=checked]:enabled:border-none relative cursor-default rounded-full outline-none cursor-pointer group",
    // hover
    "data-[state=checked]:hover:bg-ui-300 hover:enabled:bg-ui-300",
    // disabled
    "disabled:bg-ui-100 disabled:border disabled:border-base-disabled disabled:cursor-not-allowed",
    // disabled:on
    "data-[state=checked]:disabled:bg-ui-100",
  ),
  variants: {
    size: {
      md: "h-[24px] w-[48px]",
      lg: "h-[32px] w-[64px]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export const THUMB_CLASS_NAME = tv({
  base: clsx(
    "data-[state=checked]:bg-ui-white bg-ui-300 block rounded-full transition-transform duration-100 will-change-transform",
    // hover
    "group-hover:bg-ui-white",
    // disabled
    "group-disabled:bg-ui-white group-disabled:cursor-not-allowed",
  ),
  variants: {
    size: {
      md: "h-[16px] w-[16px] translate-x-[3px] data-[state=checked]:translate-x-[28px]",
      lg: "h-[24px] w-[24px] translate-x-[4px] data-[state=checked]:translate-x-[35px]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});
